import { useTranslations } from "@jugl-web/utils";
import { useState } from "react";
import { useInvoicesItemsPage } from "../../context/useInvoicesItemsPage";
import { FiltersButton } from "./FiltersButton";
import { FiltersDialog } from "./FiltersDialog";
import { useFilters } from "./FiltersDialog/hooks/useFilters";
import { FiltersConfig } from "./types";

export const InvoicesFilters = () => {
  const { t } = useTranslations();
  const [isOpen, setIsOpen] = useState(false);
  const { setFilters } = useInvoicesItemsPage();

  const filtersConfig: FiltersConfig = [
    {
      type: "checkbox",
      name: "status",
      title: t({
        id: "invoices-page.filters.by-status",
        defaultMessage: "By Status",
      }),
      options: [
        {
          label: t({
            id: "invoices-table-component.status-draft",
            defaultMessage: "Draft",
          }),
          value: "draft",
        },
        {
          label: t({
            id: "invoices-table-component.status-issued",
            defaultMessage: "Issued",
          }),
          value: "issued",
        },
        {
          label: t({
            id: "invoices-table-component.status-pending",
            defaultMessage: "Pending",
          }),
          value: "pending",
        },
        {
          label: t({
            id: "invoices-table-component.status-paid",
            defaultMessage: "Paid",
          }),
          value: "paid",
        },
        {
          label: t({
            id: "invoices-table-component.status-partially-paid",
            defaultMessage: "Partially Paid",
          }),
          value: "partially_paid",
        },
        {
          label: t({
            id: "invoices-table-component.status-overdue",
            defaultMessage: "Overdue",
          }),
          value: "overdue",
        },
        {
          label: t({
            id: "invoices-table-component.status-long-term-due",
            defaultMessage: "Long Term Due",
          }),
          value: "long_term_due",
        },
        {
          label: t({
            id: "invoices-table-component.status-void",
            defaultMessage: "Void",
          }),
          value: "void",
        },
      ],
    },
    {
      type: "checkbox",
      name: "type",
      title: t({
        id: "invoices-page.filters.by-document-type",
        defaultMessage: "By Document Type",
      }),
      options: [
        {
          label: t({
            id: "invoices-table-component.type-purchase-order",
            defaultMessage: "Purchase Order",
          }),
          value: "purchase_order",
        },
        {
          label: t({
            id: "invoices-table-component.type-estimate",
            defaultMessage: "Estimate",
          }),
          value: "estimate",
        },
        {
          label: t({
            id: "invoices-table-component.type-proforma",
            defaultMessage: "Proforma",
          }),
          value: "proforma",
        },
        {
          label: t({
            id: "invoices-table-component.type-invoice",
            defaultMessage: "Invoice",
          }),
          value: "invoice",
        },
      ],
    },
    {
      type: "date",
      name: "issue_date",
      title: t({
        id: "invoices-page.filters.by-issue-date",
        defaultMessage: "By Issue Date",
      }),
    },
    {
      type: "date",
      name: "due_date",
      title: t({
        id: "invoices-page.filters.by-due-date",
        defaultMessage: "By Due Date",
      }),
    },
    {
      type: "customer",
      name: "customer",
      title: t({
        id: "invoices-page.filters.by-customer",
        defaultMessage: "By Customer",
      }),
    },
  ];

  const filters = useFilters(filtersConfig);

  const handleApply = () => {
    setFilters(filters.getKeyValuePair());
    setIsOpen(false);
  };

  return (
    <>
      <FiltersButton
        onClick={() => setIsOpen(true)}
        hasFilters={filters.hasCommitedFilters}
        onClear={() => {
          filters.resetFilters();
          setFilters({});
        }}
      />
      <FiltersDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        filters={filters}
        onApply={handleApply}
      />
    </>
  );
};
